import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { mustChangePassword } from '../../utils/auth';

const CHANGE_PASSWORD_PATH = '/alterar-palavra-passe';

/**
 * Holds an authenticated user on the change-password screen until it is done.
 *
 * A route gate rather than a modal: it also covers deep links (`/processes/12`)
 * and cannot be dismissed from the DOM. The backend refuses every other endpoint
 * while the change is pending, so this is the UX half of the same rule.
 */
export function PasswordChangeGate() {
  const location = useLocation();
  const isPending = mustChangePassword();

  if (isPending && location.pathname !== CHANGE_PASSWORD_PATH) {
    return <Navigate to={CHANGE_PASSWORD_PATH} replace />;
  }

  // Nothing pending: the screen has no reason to stay reachable.
  if (!isPending && location.pathname === CHANGE_PASSWORD_PATH) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
